import { IObjectsControllable } from "./IObjectsControllable";
import { ILinkedPageObjectSpecifiable } from "./ILinkedPageObjectSpecifiable";

export interface IScriptExecuteTriggerBehaviorSpecifiable {
  scriptExecuteTriggerBehavior: IObjectsControllable<ILinkedPageObjectSpecifiable>;
}

export function instanceOfIScriptExecuteTriggerBehaviorSpecifiable(instance: any): instance is IScriptExecuteTriggerBehaviorSpecifiable {
  return instance
      && (instance.scriptExecuteTriggerBehavior !== undefined);
}
